import styled from 'styled-components'

export const DashBoardItemHeading = styled.div`
  font-size: 18px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #200769;

  @media (min-width: 480px) {
    font-size: 20px;
  }
  @media (min-width: 768px) {
    font-size: 28px;
  }
`

export const DashBoardSectionWrapper = styled.section`
  margin-bottom: 32px;
  @media (min-width: 768px) {
    margin-bottom: 40px;
  }
`

export const DashBoardSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b6b8c;
  margin-bottom: 8px;
`